import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { ButtonReturn } from '../../../components/common/ButtonReturn';
import { RandomQuestion } from '../../../components/common/RandomQuestion';
import { shuffleArray } from '../../../helpers/questionRandom';
import { voicesTypeControl } from '../../../types/audioType';
import { question } from '../../../assets/tema9';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	questions: 3,
	win: 4,
	fail: 5,
	dialogTwo: 6,
	dialogThree: 7,
};

let pointsWin = 0

const stepGame = [
	{
		id: 1,
		title: "Riesgo 1",
		text: "Cargar con la fuerza en las piernas y NO en la espalda, la carga debe ir pegada al cuerpo.",
		img: question.p1
	},
	{
		id: 2,
		title: "Riesgo 2",
		text: "Mantente atento, cuida tus manos y no te expongas a accidentes.",
		img: question.p2
	},
	{
		id: 3,
		title: "Riesgo 3",
		text: "Mantén limpios los pisos al usar la escalera, revisa que esté en buenas condiciones y apóyate en 3 puntos.",
		img: question.p3
	},
	{
		id: 4,
		title: "Riesgo 4",
		text: `Imprime el ticket y enfajilla el dinero.`,
		img: question.p4
	},
	{
		id: 5,
		title: "Riesgo 5",
		text: "Firmas el ticket de quien elabora y quien verifica.",
		img: question.p5
	},
];

export const Theme9SubtopicOneActivityFour = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema9.activities.subtema1], 4);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 9 sub 1 act 4");
			ObserverEmitter.emit(EVENTS.tema9.topic1.initScene, 4);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.subtema1.sub4a01)
	})


	const [numberQuestion, setNumberQuestion] = useState(0);
	const [questionGameOne, setQuestionGameOne] = useState([]);
	const [saveResponsesGameOne, setSaveResponsesGameOne] = useState([]);
	const [responseQuestionGameOne, setResponseQuestionGameOne] = useState([]);


	const checkCorrectsInGameOne = (array = []) => {
		const trueElements = array.filter(element => element === true);
		return trueElements.length >= 2;
	}

	const getRandomQuestionGame = useCallback(() => {
		const newQuestion = stepGame.slice(0, 3);
		const newResponse = shuffleArray(stepGame);
		setQuestionGameOne(newQuestion);
		setResponseQuestionGameOne(newResponse);
	}, []);

	useEffect(() => {
		getRandomQuestionGame();
	}, [getRandomQuestionGame]);

	const finishSubactivityOne = (isWin = false) => {
		if (isWin) {
			setUiToShow(steps.win);
		} else {
			setUiToShow(steps.fail);
		}
	};

	const condition = (client) => client.id === questionGameOne[numberQuestion + 1].id;

	const verificationResponse = (selectNumber = -1) => {
		if (selectNumber === -1) {
			return;
		}

		if (numberQuestion + 1 >= questionGameOne.length + 1) {
			const resultadoThreeWin = checkCorrectsInGameOne(saveResponsesGameOne)
			finishSubactivityOne(resultadoThreeWin);
			return;
		}

		//* verificar si es correcto
		const isCorrectResponse = questionGameOne[numberQuestion].id === selectNumber;
		const saveGame = [...saveResponsesGameOne, isCorrectResponse];

		if (isCorrectResponse) {
			pointsWin += 10
		}

		if (numberQuestion + 1 === questionGameOne.length) {
			const resultadoThreeWin = checkCorrectsInGameOne(saveGame)
			finishSubactivityOne(resultadoThreeWin);
			return;
		}

		//* revolver respuestas
		const matchingObject = stepGame.find(condition);
		const nonMatchingObjects = stepGame.filter((client) => !condition(client));
		const shuffleNonMatchingObjects = shuffleArray(nonMatchingObjects);
		const sliceNonMatchingObjects = shuffleNonMatchingObjects.slice(0, 4);
		sliceNonMatchingObjects.push(matchingObject);
		const shuffleNewResponse = shuffleArray(sliceNonMatchingObjects);


		//* guardar state
		setResponseQuestionGameOne(shuffleNewResponse);
		setNumberQuestion(numberQuestion + 1);
		setSaveResponsesGameOne(saveGame);
	};

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 3].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema9.topic1.initScene, 4);
						pointsWin = 0
						getRandomQuestionGame()
						setNumberQuestion(0)
						setSaveResponsesGameOne([])
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name='Ejercicio: Selecciona la opción correcta.' />
					<DialogBarNew
						dialog={`Selecciona los riesgos que puedan surgir en la Tienda, con las acciones correspondientes para prevenirlos.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1. SASSO"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.questions);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.questions && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<BarStatusActivies
						activities={tasksList}
					/>
					<RandomQuestion
						textStyleContainerQuestion={"text-[16px]"}
						action={verificationResponse}
						numberQuestion={numberQuestion}
						arrayQuestion={questionGameOne}
						anserwerQuestion={responseQuestionGameOne}
					/>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={pointsWin}
						dialogModal="¡Excelente trabajo! Has relacionado correctamente los principales riesgos en Tienda"
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 4,
									pointsWin: pointsWin,
									subtema: tasksId.tema9.activities.subtema1
								})
							);
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.characterAnimations.festejo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.fin.fin01)
						}}
					/>
				</>
			)}

			{uiToShow === steps.fail && (
				<>
					<ValidationResultModal
						title="Respuesta incorrecta."
						dialogModal="¡Lo siento! parece que tuviste dificultades al relacionar correctamente los principales riesgos en Tienda"
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 4,
									pointsWin: pointsWin,
									subtema: tasksId.tema9.activities.subtema1
								})
							);
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.characterAnimations.festejo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.fin.fin01)
						}}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<HeaderRedPresentation name='Final del curso' />
					<DialogBarNew
						dialog={`Ahora sí, ya terminaste todos los temas por ver en tu capacitación. Ha llegado la hora de despedirme.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.fin.fin02)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<HeaderRedPresentation name='Final del curso' />
					<DialogBarNew
						dialog={`Has aprendido mucho. Ya cuentas con más conocimientos para hacer todas tus actividades en tu tienda.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							navigator("/home9/tema9/subtema1/activityresult");
						}}
					></DialogBarNew>
				</>
			)}

		</>
	)
}
